import React from 'react'

import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomModal,
  InputNumeroDecimal,
  InputTime,
  NumeroDecimal,
} from '../../../../components'

export default function ModalCriarMovimentacao({
  visible,
  onClose,
  result,
  estoques,
  posicoes,
  operacoes,
  form,
  onEstoqueChange,
  onChange,
  onSalvar,
  loadingPosicoes,
  loadingOperacoes,
}) {
  if (!result) return null

  const quantidadeNumber = Number(form.quantidade)
  const diferencaNumber = Math.abs(Number(result.diferenca) || 0)
  const quantidadeDivergeDaDiferenca =
    !Number.isFinite(quantidadeNumber) || Math.abs(quantidadeNumber - diferencaNumber) > 0.000001
  const showQuantidadeWarning =
    form.quantidade !== '' && quantidadeDivergeDaDiferenca

  return (
    <CustomModal
      isVisible={visible}
      header="Criar Movimentação"
      onClose={onClose}
      width="94vw"
      style={{ maxWidth: 1280 }}
    >
      <div className="p-grid">
        <div className="p-col-12" style={{ marginBottom: 8 }}>
          <strong>Produto:</strong> {`${result.product.product_code} - ${result.product.name}`}
        </div>

        <div className="p-col-12 p-md-4">
          <strong>Saldo Total Estoque:</strong>{' '}
          <NumeroDecimal>{result.saldo_total_estoque}</NumeroDecimal>
        </div>
        <div className="p-col-12 p-md-4">
          <strong>Saldo Final Movimentações:</strong>{' '}
          <NumeroDecimal>{result.saldo_final_movimentacoes}</NumeroDecimal>
        </div>
        <div className="p-col-12 p-md-4">
          <strong>Diferença:</strong> <NumeroDecimal>{result.diferenca}</NumeroDecimal>
        </div>

        <div className="p-col-12 p-md-4">
          <CustomDropdown
            label="Estoque"
            filter={true}
            optionLabel="name"
            options={estoques}
            value={form.selectedEstoque}
            onChange={onEstoqueChange}
            placeholder="Selecione um Estoque"
          />
        </div>
        <div className="p-col-12 p-md-4">
          <CustomDropdown
            label="Posição de Estoque"
            filter={true}
            optionLabel="endereco"
            options={posicoes}
            value={form.selectedPosicaoEstoque}
            onChange={value => onChange('selectedPosicaoEstoque', value)}
            disabled={!form.selectedEstoque || loadingPosicoes}
            placeholder={loadingPosicoes ? 'Carregando posições...' : 'Selecione uma Posição'}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <CustomDropdown
            label="Operação de Estoque"
            filter={true}
            optionLabel="label"
            options={operacoes}
            value={form.selectedOperacaoEstoque}
            onChange={value => onChange('selectedOperacaoEstoque', value)}
            disabled={loadingOperacoes}
            placeholder={loadingOperacoes ? 'Carregando operações...' : 'Selecione uma Operação'}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <CustomCalendar
            label="Data da Movimentação"
            onChange={value => onChange('dataMovimentacao', value)}
            value={form.dataMovimentacao}
          />
        </div>
        <div className="p-col-12 p-md-6" style={{ marginTop: -10 }}>
          <InputTime
            label="Hora da Movimentação"
            value={form.horaMovimentacao}
            onChange={value => onChange('horaMovimentacao', value)}
          />
        </div>
        <div className="p-col-12 p-md-6">
          <InputNumeroDecimal
            label="Quantidade"
            value={form.quantidade}
            onChange={value => onChange('quantidade', value)}
          />
          {showQuantidadeWarning ? (
            <div style={{ marginTop: 8, color: '#D35400', fontSize: '0.85rem', lineHeight: 1.5 }}>
              Atenção! O valor digitado não é igual ao da Diferença entre os saldos. A operação
              pode ser realizada normalmente, porém recomendamos verificar e confirmar se as
              informações estão corretas antes de continuar.
            </div>
          ) : null}
        </div>
      </div>

      <div style={{ marginTop: 24, textAlign: 'right' }}>
        <Btn onClick={onSalvar}>Salvar</Btn>
      </div>
    </CustomModal>
  )
}
